class Analytics {
  constructor() {
    if (Analytics.instance) {
      // eslint-disable-next-line no-constructor-return
      return Analytics.instance;
    }
    Analytics.instance = this;
  }

  // eslint-disable-next-line class-methods-use-this
  pushEvent(eventData) {
    if (typeof window !== 'undefined') {
      if (eventData.ecommerce) {
        window.dataLayer.push({ ecommerce: null });
      }

      window.dataLayer.push(eventData);
    }
  }

  sendPageview(eventPayload) {
    this.pushEvent({ event: 'pageview', ...eventPayload });
  }
}

const analyticsInstance = new Analytics();

export default analyticsInstance;
